import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AuthModel } from '@models/auth.model';
import { NotificationModel } from '@models/common.model';
import { Pageable, ResponseAPI } from '@models/response';
import { UserModel } from '@modules/admin/pages/n03/n03.model';
import { ProductModel } from '@modules/admin/pages/n06/n06.model';
import { catchError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BaseService {
  httpClient = inject(HttpClient);

  getUploadFile(file) {
    return this.httpClient
      .post<ResponseAPI<string>>('/bot/upload', file)
      .pipe(catchError(() => this.httpClient.post<ResponseAPI<string>>('/files/upload', file)));
  }
  // upload nhiều file
  getUploadFiles(file) {
    return this.httpClient.post<ResponseAPI<string[]>>('/bot/upload/all', file).pipe(
      catchError(() => {
        return this.httpClient.post<ResponseAPI<string[]>>('/files/upload/all', file);
      })
    );
  }

  getCommonUser(name: string) {
    return this.httpClient.get<ResponseAPI<UserModel[]>>(`/common/search/user?keyword=${name}`);
  }

  getCommonShop(name: string) {
    return this.httpClient.get<ResponseAPI<UserModel[]>>(`/common/search/shop?keyword=${name}`);
  }

  getcommonProduct(productName: string) {
    return this.httpClient.get<ResponseAPI<ProductModel[]>>(`/common/search/products?keyword=${productName}`);
  }

  getChangePassword(id: number, model) {
    return this.httpClient.post<ResponseAPI<{}>>(`/common/change-password/${id}`, model);
  }

  getChangeAvatar(id: number, model) {
    return this.httpClient.put<ResponseAPI<{}>>(`/common/change-avatar/${id}`, model);
  }

  getResetPassword(user) {
    return this.httpClient.post<ResponseAPI<boolean>>('/auth/forgot', user);
  }

  getNotification() {
    return this.httpClient.get<ResponseAPI<Pageable<NotificationModel[]>>>('/notification/admin');
  }

  getListNotifications() {
    return this.httpClient.put<ResponseAPI<Pageable<NotificationModel[]>>>('/notification/read/all/admin', {});
  }

  /**
   * Dựa vào token lấy thông tin người dùng
   * @returns 
   */
  getInfoRegister(token: string) {
    return this.httpClient.get<ResponseAPI<UserModel>>(`/N033/referer?token=${token}`);
  }

  /**
   * 
   * @returns 
   */
  getListNutridayShop02() {
    return this.httpClient.get<ResponseAPI<Pageable<any>>>(`/common/search/shop/profile?page=1&size=999999&sortField=createdDate&sort=desc&keyword=`);
  }
  getCategories02() {
    return this.httpClient.get<ResponseAPI<Pageable<any>>>(`/N06/categories?page=1&size=9999&sortField=createdDate&sort=desc`);
  }
}
